export default __webpack_public_path__ + "static/media/2502103.b625050c.jpg";